(function () {
  'use strict';

  angular
    .module('app.segmentationReportInfluencerOverview')
    .controller('segmentationReportInfluencerOverviewCtrl', segmentationReportInfluencerOverviewCtrl);

  segmentationReportInfluencerOverviewCtrl.$inject = ['measureService', 'segmentationReportInfluencerOverviewService', '$scope', '$rootScope'];
  function segmentationReportInfluencerOverviewCtrl(measureService, segmentationReportInfluencerOverviewService, $scope, $rootScope) {

    var pieChartConfig = {
      options: {
        chart: {
          type: 'pie',
          zoomType: 'x',
          backgroundColor: null,
          marginTop: 16
        },
        tooltip: {
          enabled: false
        },
        plotOptions: {
          pie: {
            allowPointSelect: false,
            cursor: 'pointer',
            dataLabels: {
              enabled: false
            },
            showInLegend: false
          }
        },
        credits: {
          enabled: false
        }
      },
      series: [{
        size: '80%',
        innerSize: '90%'
      }],
      title: {
        text: '',
        style: {
          fontSize: '16px',
          color: '#4B5567',
          fontFamily: 'ProximaNovaSemibold'
        }
      },
      xAxis: {
        type: 'datetime',
        title: {
          text: 'Date'
        }
      },
      noData: 'Pending Data...',
      loading: true
    };

    var pieChartConfigHaveLegend = {
      options: {
        chart: {
          type: 'pie',
          backgroundColor: null,
          marginBottom: 1,
          marginLeft: 0,
          marginRight: 200,
          marginTop: 0
        },
        tooltip: {
          enabled: false
        },
        plotOptions: {
          pie: {
            allowPointSelect: false,
            cursor: 'pointer',
            dataLabels: {
              enabled: false
            },
            showInLegend: true
          }
        },
        credits: {
          enabled: false
        },
        legend: {
          symbolHeight: 12,
          symbolWidth: 12,
          symbolRadius: 6,
          verticalAlign:'middle',
          align: 'right',
          layout: 'vertical',
          width: 170,
          itemStyle: {
            fontWeight: '500'
          },
          labelFormatter: function () {
            return '<span style="display: block">'
              + this.name + ' - '
              + Math.round(this.y*1000)/10 +'%' +
              '</span>';}
        }
      },
      series: [{
        size: '100%',
        innerSize: '85%'
      }],
      title: {
        text: 'NATIONALITY',
        style: {
          fontSize: '16px',
          color: '#4B5567',
          fontFamily: 'ProximaNovaSemibold'
        },
        align: 'left'
      },
      xAxis: {
        type: 'datetime',
        title: {
          text: 'Date'
        }
      },
      noData: 'Pending Data...',
      loading: true
    };

    var pieChartConfigForPrint = {
      options: {
        chart: {
          type: 'pie',
          backgroundColor: null,
          marginBottom: 1,
          marginLeft: 3,
          marginRight: 223,
          marginTop: 50
        },
        tooltip: {
          enabled: false
        },
        plotOptions: {
          pie: {
            allowPointSelect: false,
            cursor: 'pointer',
            dataLabels: {
              enabled: false
            },
            showInLegend: true
          }
        },
        credits: {
          enabled: false
        },
        legend: {
          symbolHeight: 12,
          symbolWidth: 12,
          symbolRadius: 6,
          verticalAlign:'middle',
          align: 'right',
          layout: 'vertical',
          width: 170,
          x: -21,
          itemStyle: {
            fontWeight: '500',
            fontSize: '20px'
          },
          labelFormatter: function () {
            return '<span style="display: block">'
              + this.name + ' - '
              + Math.round(this.y*1000)/10 +'%' +
              '</span>';}
        }
      },
      series: [{
        size: '100%',
        innerSize: '85%'
      }],
      title: {
        text: 'NATIONALITY',
        x: -11,
        style: {
          fontSize: '24px',
          color: '#4B5567',
          fontFamily: 'ProximaNovaSemibold',
        },
        align: 'left'
      },
      xAxis: {
        type: 'datetime',
        title: {
          text: 'Date'
        }
      },
      noData: 'Pending Data...',
      loading: true
    };

    var barChartConfig  = {
      options: {
        chart: {
          type: 'column',
          zoomType: 'x'
        },
        tooltip: {
          enabled: false
        },
        plotOptions: {
          column: {
            dataLabels: {
              enabled: false
            },
            showInLegend: false
          },
          series: {
            borderWidth: 0,
            dataLabels: {
              allowOverlap: true,
              enabled: true,
              crop: false,
              overflow: 'none',
              format: '{point.y:.0f}'
            },
            pointWidth: 40,
            states: {
                hover: {
                    enabled: false
                }
            }
          }
        },
        credits: {
          enabled: false
        }
      },
      series: [],
      title: {
        text: 'PLATFORMS',
        textAnchor: 'left',
        style: {
          fontSize: '16px',
          color: '#4B5567',
          fontFamily: 'ProximaNovaSemibold'
        }
      },
      xAxis: {
        type: 'category',
        tickLength: 0,
        labels: {

        }
      },
      yAxis: {
        title: {
          text: false
        },
        labels: {
          enabled: false
        }
      },
      noData: 'Pending Data...',
      loading: true
    };

    var barChartConfigForPrint  = {
      options: {
        chart: {
          type: 'column',
          zoomType: 'x'
        },
        tooltip: {
          enabled: false
        },
        plotOptions: {
          column: {
            dataLabels: {
              enabled: false
            },
            showInLegend: false
          },
          series: {
            borderWidth: 0,
            dataLabels: {
              allowOverlap: true,
              enabled: true,
              crop: false,
              overflow: 'none',
              format: '{point.y:.0f}',
              style: {
                  fontSize: '20px'
              }
            },
            pointWidth: 40,
            states: {
                hover: {
                    enabled: false
                }
            }
          }
        },
        credits: {
          enabled: false
        }
      },
      series: [],
      title: {
        text: 'PLATFORMS',
        textAnchor: 'left',
        style: {
          fontSize: '24px',
          color: '#4B5567',
          fontFamily: 'ProximaNovaSemibold'
        }
      },
      xAxis: {
        type: 'category',
        tickLength: 0,
        labels: {
            style: {
                fontSize: '20px'
            }
        }
      },
      yAxis: {
        title: {
          text: false
        },
        labels: {
          enabled: false
        },
        gridLineColor: '#fff'
      },
      noData: 'Pending Data...',
      loading: true
    };

    $scope.$on('refreshDashboard', function(event, args) {
      getDataSegmentationReportInfluencerOverview();
    });

    function generateInfluencersData(influencers) {
      $scope.influencers = $scope.influencers || {};

      // kpi
      $scope.influencers.kpi = influencers;
    }

    function generateNationalityData(nationalities) {
      // nationality
      $scope.influencers = $scope.influencers || {};
      $scope.influencers.nationality = {
        pieChartConfig : {
          series: []
        }
      };
      var nationality = _.get(nationalities, 'nationality');
      var config = angular.copy(pieChartConfigHaveLegend);

      config.options.chart.width = 313;
      config.options.plotOptions = {
        series: {
          states: {
            hover: {
              enabled: false
            }
          }
        },
        pie: {
          allowPointSelect: false,
          cursor: 'pointer',
          dataLabels: {
            enabled: false
          },
          showInLegend: true
        }
      };

      var dataPieChart = [];
      _.forEach(nationality, function (item) {
        dataPieChart.push({name: item.name, y: Math.round(item.percent*100)/100, color:item.color});
      });
      config.series[0].data = dataPieChart;
      config.series[0].name = 'Nationality';
      config.series[0].size = '130%';
      $scope.influencers.nationality.pieChartConfig = config;
      //chart for print
      var configForPrintChart = angular.copy(pieChartConfigForPrint);

      configForPrintChart.options.chart.width = 354;
      configForPrintChart.options.plotOptions = {
        series: {
          states: {
            hover: {
              enabled: false
            }
          }
        },
        pie: {
          allowPointSelect: false,
          cursor: 'pointer',
          dataLabels: {
            enabled: false
          },
          showInLegend: true
        }
      };

      var dataPieChart = [];
      _.forEach(nationality, function (item) {
        dataPieChart.push({name: item.name, y: Math.round(item.percent*100)/100, color:item.color});
      });
      configForPrintChart.series[0].data = dataPieChart;
      configForPrintChart.series[0].name = 'Nationality';
      configForPrintChart.series[0].size = '130%';

      $scope.influencers.nationality.pieChartConfigForPrint = configForPrintChart;
    }

    function generatePlatformsData(platforms) {
      // platforms
      $scope.influencers = $scope.influencers || {};
      $scope.influencers.platforms = {
        barChartConfig : {
          series: []
        },
        barChartConfigForPrint : {
          series: []
        }
      };
      var barConfig = angular.copy(barChartConfig);
      barConfig.options.chart.width = 313;
      var barSeries = {
        name: 'Platforms',
        data: []
      };
      _.forEach(platforms.chartData, function (item) {
        barSeries.data.push({name: item.name, y: item.value, color: item.color});
      });
      barConfig.series.push(barSeries);
      $scope.influencers.platforms.barChartConfig = barConfig;
      // $scope.$broadcast('highchartsng.reflow');

      //for print chart
      var barConfigForPrint = angular.copy(barChartConfigForPrint);
      barConfigForPrint.options.chart.width = 313;
      var barSeries = {
        name: 'Platforms',
        data: []
      };
      _.forEach(platforms.chartData, function (item) {
        barSeries.data.push({name: item.name, y: item.value, color: item.color});
      });
      barConfigForPrint.series.push(barSeries);
      $scope.influencers.platforms.barChartConfigForPrint = barConfigForPrint;
    }

    function getDataSegmentationReportInfluencerOverview() {
      var params = $rootScope.saveParams;
      if(params == null || (params.mention == 0 && params.blog_id == 0 && params.project_id == 0 && params.channel == 0 && params.influencerGroup == 0)) {
        return;
      }
      params.date = $rootScope.selectedPeriod.period ? $rootScope.selectedPeriod.period.value : 7;

      getSegmentInfluencersData(params);
    }

    function getSegmentInfluencersData(params){
      segmentationReportInfluencerOverviewService.getSegmentInfluencersData(params)
        .then(function(response){
            generateInfluencersData(response.influencers);
            generateNationalityData(response.nationalities);
            generatePlatformsData(response.platforms);
        })
        .catch(function(message){
          $scope.influencers = null;
        })
        .finally(function(){
          $rootScope.$broadcast('sectionLoaded');
        })            
    }
    
    // first initiating
    getDataSegmentationReportInfluencerOverview();
  }
})();